export const priceBuckets = [
  { id: 'u250', label: 'Tot € 250', min: 0, max: 250 },
  { id: '250-1000', label: '€ 250 – € 1.000', min: 250, max: 1000 },
  { id: '1000-2500', label: '€ 1.000 – € 2.500', min: 1000, max: 2500 },
  { id: 'o2500', label: '€ 2.500 +', min: 2500, max: Infinity },
] as const;

export const capacityBuckets = [
  { id: 'u1', label: 'Tot 1 kWh', min: 1, max: 1000 },
  { id: '1-3', label: '1 – 3 kWh', min: 1000, max: 3000 },
  { id: '3-10', label: '3 – 10 kWh', min: 3000, max: 10000 },
  { id: 'o10', label: '10 kWh +', min: 10000, max: Infinity },
] as const;

export const sortOptions = [
  { id: 'popular', label: 'Populariteit' },
  { id: 'price-asc', label: 'Prijs: laag naar hoog' },
  { id: 'price-desc', label: 'Prijs: hoog naar laag' },
  { id: 'rating', label: 'Best beoordeeld' },
] as const;

export const reviews = [
  {
    name: 'Marieke V.',
    location: 'Utrecht',
    rating: 5,
    date: 'sep 2026',
    text: 'Maandag besteld, de week erna geïnstalleerd. In de app zie je precies wat je bespaart — tot nu toe zo’n € 60 per maand.',
  },
  {
    name: 'Thomas de B.',
    location: 'Gent',
    rating: 5,
    date: 'aug 2026',
    text: 'Helder advies aan de telefoon, ze raadden me het grotere model zelfs af omdat ik het niet nodig had. Snel geleverd, goed verpakt.',
  },
  {
    name: 'Sanne K.',
    location: 'Eindhoven',
    rating: 4,
    date: 'aug 2026',
    text: 'Top product. Installeren duurde iets langer dan verwacht, maar de klantenservice hielp me binnen een paar minuten verder.',
  },
];
